import { CapturedPhoto } from '@core/index';
import { QuoteStatus } from './quotes.model';

export type OrderStatus =
  | 'RECEIVED'
  | 'PRE_REVIEW'
  | 'QUOTED'
  | 'APPROVED'
  | 'IN_PROGRESS'
  // | 'WASHING'
  | 'COMPLETED'
  | 'CLOSED'
  | 'CANCELLED';

export type StageKey = 'reception' | 'review' | 'execution' | 'additional';

export const STAGE_STATUS_FLOW: OrderStatus[] = [
  'RECEIVED',
  'PRE_REVIEW',
  'QUOTED',
  'APPROVED',
  'IN_PROGRESS',
  'COMPLETED',
  'CLOSED',
];

export const STAGE_BUCKETS: Record<StageKey, OrderStatus[]> = {
  reception: ['RECEIVED'],
  review: ['PRE_REVIEW', 'QUOTED', 'APPROVED'],
  execution: ['IN_PROGRESS', 'COMPLETED', 'CLOSED'],
  additional: ['IN_PROGRESS', 'COMPLETED', 'CLOSED'],
};

export const STAGE_DEFINITIONS: { key: StageKey; label: string; icon: string }[] = [
  { key: 'reception', label: 'Recepción vehículo', icon: 'fa-solid fa-car-side' },
  { key: 'review', label: 'Revisión técnica', icon: 'fa-solid fa-camera' },
  {
    key: 'execution',
    label: 'Ejecución de servicios',
    icon: 'fa-solid fa-screwdriver-wrench',
  },
  {
    key: 'additional',
    label: 'Servicios adicionales',
    icon: 'fa-solid fa-circle-plus',
  },
];
export interface WorkOrderVehicleSummary {
  plate: string;
  brand: string;
  model: string;
  year: number;
  engineCc: number;
}

export interface WorkOrderCustomerSummary {
  user: string;
  phone: string;
}

export interface WorkOrderTechnicianSummary {
  id: string;
  name: string;
}

export interface WorkOrder {
  id: string;
  vehicle: WorkOrderVehicleSummary;
  entryDate: string;
  status: OrderStatus;
  hasTechnician: boolean;
  technician: WorkOrderTechnicianSummary | null;
  hasTechnicianReview: boolean;
  technicianReview: WorkOrderTechnicianSummary | null;
  km: number;
  customer: WorkOrderCustomerSummary;
  quote?: QuoteStatus;
}

export interface WorkOrderTakeResultOrder {
  id: string;
  vehicleId: string;
  currentKm: number;
  status: OrderStatus;
  fuelLevel: number | null;
}

export interface WorkOrderTechnicalReview {
  id: string;
  notes: string;
  status: string;
  items: WorkOrderTechnicalReviewItem[];
}

export interface WorkOrderTechnicalReviewItem {
  id: string;
  serviceId: string;
  name: string;
  description: string;
  diagnosis: string;
}

export interface WorkOrderTakeResultInspection {
  id: string;
  notes: string | null;
  photos: CapturedPhoto[];
}

export interface WorkOrderTakeResultCustomer {
  name: string;
}

export interface WorkOrderTakeResultVehicle {
  plate: string;
  dataVehicle: string;
}

export interface WorkOrderTakeRequestedService {
  id: string;
  serviceCatalogId: string | null;
  description: string | null;
  approved?: boolean | null;
  notes?: string | null;
  service: {
    id: string;
    name: string;
  } | null;
}

export interface WorkOrderChecklistItem {
  id: string;
  name: string;
  status: string;
  notes: string | null;
}

export type WorkOrderChecklist = Record<string, WorkOrderChecklistItem[]>;

export interface WorkOrderTakeResult {
  order: WorkOrderTakeResultOrder;
  customer: WorkOrderTakeResultCustomer | null;
  vehicle: WorkOrderTakeResultVehicle | null;
  receptionPhotos: CapturedPhoto[];
  inspection: WorkOrderTakeResultInspection | null;
  requestedServices: WorkOrderTakeRequestedService[];
  checklist: WorkOrderChecklist;
  technicalReview: WorkOrderTechnicalReview | null;
  vehiclePlate?: string;
}
